export default {
  TITLE: 'Endereço',
};
